import { useEffect } from 'react'

export const useLockBodyScroll = (isOpen) => {
    useEffect(() => {
        const originalStyle = window.getComputedStyle(document.body).overflow
        const scrollPos = window.scrollY

        if (isOpen) {
            document.body.style.overflow = 'hidden'
            document.body.style.position = 'fixed'
            document.body.style.top = `-${scrollPos}px`
            document.body.style.width = '100%'
        }
        return () => {
            document.body.style.overflow = originalStyle
            document.body.style.removeProperty('position')
            document.body.style.removeProperty('top')
            document.body.style.removeProperty('width')
            if (isOpen) {
                window.scrollTo(0, scrollPos)
            }
        }
    }, [isOpen])
}

export default useLockBodyScroll
